<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <span id="log"></span> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight
    };
  },
  created() {
    this.getStart();
  },
  methods: {
    getStart() {
      if (this.screenHeight > this.screenWidth) {
        this.$router.push({ path: "/phone" });
      } else if (this.screenHeight < this.screenWidth) {
        this.$router.push({ path: "/off/home" });
      }
    }
  }
};
</script>

<style lang="less">
#app {
  width: 100%;
  height: 100%;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  /* margin-top: 60px; */
  #log {
    display: block;
    width: 9.2%;
    height: 7%;
    position: absolute;
    background-size: 100% 100%;
    left: 20%;
    top: 4%;
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue